import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2052Status: 'idle',
    startProcess2052Error: undefined as any,
    loadUserParamsProcess2052Status: 'idle',
    loadUserParamsProcess2052Error: undefined as any,

    process2052List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2052 = createAsyncThunk('process2052Slice/startProcess2052', async ({ process2052 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2052/`,
        prepareData(process2052),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2052Status } = getState().process2052Slice
        return startProcess2052Status !== 'pending'
    }
})

export const loadUserParamsProcess2052 = createAsyncThunk('process2052Slice/loadUserParamsProcess2052', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2052/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2052Status } = getState().process2052Slice
        return loadUserParamsProcess2052Status !== 'pending'
    }
})

const Process2052Slice = createSlice({
    name: 'process2052Slice',
    initialState,
    reducers: {
        resetstartProcess2052: (state) => {
            state.job = undefined
            state.startProcess2052Error = undefined
        },
        resetstartProcess2052Error: (state) => {
            state.startProcess2052Error = undefined
        },
        resetloadUserParamsProcess2052: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2052Error = undefined
        },
        resetloadUserParamsProcess2052Error: (state) => {
            state.loadUserParamsProcess2052Error = undefined
        },
        removeFromProcess2052ListById: (state, action) => {
            state.process2052List = state.process2052List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2052ListByIds: (state, action) => {
            state.process2052List = state.process2052List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2052List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2052Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2052List = []
            state.startProcess2052Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2052.pending, (state) => {
            state.startProcess2052Status = 'pending'
            state.startProcess2052Error = undefined
        })
        builder.addCase(startProcess2052.fulfilled, (state, action) => {
            state.startProcess2052Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2052.rejected, (state, action) => {
            state.startProcess2052Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2052Error = action.error.message
            } else {
                state.startProcess2052Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2052.pending, (state) => {
            state.loadUserParamsProcess2052Status = 'pending'
            state.loadUserParamsProcess2052Error = undefined
        })
        builder.addCase(loadUserParamsProcess2052.fulfilled, (state, action) => {
            state.loadUserParamsProcess2052Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2052.rejected, (state, action) => {
            state.loadUserParamsProcess2052Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2052Error = action.error.message
            } else {
                state.loadUserParamsProcess2052Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2052,
    resetstartProcess2052Error,
    resetloadUserParamsProcess2052,
    resetloadUserParamsProcess2052Error,
    removeFromProcess2052ListById,
    removeFromProcess2052ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2052Slice.actions
export default Process2052Slice.reducer
